const messages = {
  en: {
    translations: {
      signup: {
        title: 'Sign up',
        toasts: {
          success: 'Sign up successful! Log in to access the system.',
          fail: 'Error creating user. Check the reported data.',
        },
        form: {
          name: 'Name',
          email: 'Email',
          password: 'Password',
        },
        buttons: {
          submit: 'Register',
          login: 'Already have an account? Log in!',
        },
      },
      login: {
        title: 'Login',
        form: {
          email: 'Email',
          password: 'Password',
        },
        buttons: {
          submit: 'Enter',
          register: "Don't have an account? Register!",
        },
      },
      auth: {
        toasts: {
          success: 'Login successfully!',
        },
      },
      dashboard: {
        charts: {
          perDay: {
            title: 'Tickets today: ',
          },
        },
      },
      contactImportWpModal: {
        title: 'Export Contacts to Excel',
        exportSuccess: 'Export completed successfully!',
        buttons: {
          downloadModel: 'Download Excel template for import',
          closed: 'Close',
          import: 'Select the Excel file to import Contacts',
        },
      },
      connections: {
        title: 'Connections',
        toasts: {
          deleted: 'WhatsApp connection deleted sucessfully!',
          disconnected: 'Connection disconnected successfully!',
        },
        facebook: {
          success: 'Facebook/Instagram connection connected successfully!',
          errorConfig: 'Facebook configuration not available.',
          connecting: 'Connecting...',
          redirecting: 'Redirecting...',
          errorRedirect: 'Error. Redirecting...',
          errorNoUserId: 'Could not get user ID.',
          popupBlocked: 'Popup blocked. Please allow popups for this site and try again.',
        },
        meta: {
          openAuth: 'Authorization window opened. Complete the flow.',
        },
        confirmationModal: {
          deleteTitle: 'Delete',
          deleteMessage: 'Are you sure? It cannot be reverted.',
          disconnectTitle: 'Disconnect',
          disconnectMessage: "Are you sure? You'll need to read QR Code again.",
          disconnectMetaMessage:
            'Are you sure? The Facebook/Instagram integration will be disconnected.',
        },
        buttons: {
          add: 'Add WhatsApp',
          disconnect: 'Disconnect',
          tryAgain: 'Try Again',
          qrcode: 'QR CODE',
          newQr: 'New QR CODE',
          connecting: 'Connectiing',
        },
        toolTips: {
          disconnected: {
            title: 'Failed to start WhatsApp session',
            content:
              'Make sure your cell phone is connected to the internet and try again, or request a new QR Code',
            titleMeta: 'Failed to connect with Facebook/Instagram',
            contentMeta:
              'The connection with Facebook or Instagram was lost. Click reconnect to reauthorize.',
          },
          qrcode: {
            title: 'Waiting for QR Code read',
            content:
              "Click on 'QR CODE' button and read the QR Code with your cell phone to start session",
          },
          connected: {
            title: 'Connection established',
          },
          timeout: {
            title: 'Connection with cell phone has been lost',
            content:
              "Make sure your cell phone is connected to the internet and WhatsApp is open, or click on 'Disconnect' button to get a new QRcode",
          },
        },
        table: {
          name: 'Name',
          status: 'Status',
          lastUpdate: 'Last Update',
          default: 'Default',
          actions: 'Actions',
          session: 'Session',
        },
      },
      whatsappModal: {
        title: {
          add: 'Add WhatsApp',
          edit: 'Edit WhatsApp',
        },
        form: {
          name: 'Name',
          default: 'Default',
          allowGroup: 'Allow groups',
          groupAsTicket: 'Treat groups as ticket',
          importMax30Days: 'The import period cannot exceed 30 days',
          importMax30DaysHint: 'Maximum 30 days between dates',
        },
        buttons: {
          okAdd: 'Add',
          okEdit: 'Save',
          cancel: 'Cancel',
        },
        menuItem: {
          disabled: 'Disabled',
          enabled: 'Enabled',
        },
        success: 'WhatsApp saved successfully.',
      },
      qrCode: {
        message: 'Read QrCode to start the session',
      },
      contacts: {
        title: 'Contacts',
        toasts: {
          deleted: 'Contact deleted sucessfully!',
        },
        searchPlaceholder: 'Search ...',
        confirmationModal: {
          deleteTitle: 'Delete',
          importTitlte: 'Import contacts',
          deleteMessage:
            'Are you sure you want to delete this contact? All related tickets will be lost.',
          importMessage: 'Do you want to import all contacts from the phone?',
        },
        buttons: {
          import: 'Import Contacts',
          add: 'Add Contact',
        },
        table: {
          name: 'Name',
          whatsapp: 'WhatsApp',
          email: 'Email',
          actions: 'Actions',
        },
      },
      contactModal: {
        title: {
          add: 'Add contact',
          edit: 'Edit contact',
        },
        form: {
          mainInfo: 'Contact details',
          extraInfo: 'Additional information',
          name: 'Name',
          number: 'Whatsapp number',
          email: 'Email',
          extraName: 'Field name',
          extraValue: 'Value',
        },
        buttons: {
          addExtraInfo: 'Add information',
          okAdd: 'Add',
          okEdit: 'Save',
          cancel: 'Cancel',
        },
        success: 'Contact saved successfully.',
      },
      queueModal: {
        title: {
          add: 'Add queue',
          edit: 'Edit queue',
        },
        form: {
          name: 'Name',
          color: 'Color',
          greetingMessage: 'Greeting Message',
        },
        buttons: {
          okAdd: 'Add',
          okEdit: 'Save',
          cancel: 'Cancel',
        },
      },
      userModal: {
        title: {
          add: 'Add user',
          edit: 'Edit user',
        },
        form: {
          name: 'Name',
          email: 'Email',
          password: 'Password',
          profile: 'Profile',
          profileOwner: 'Owner',
          profileSuperAdmin: 'Super Admin',
        },
        buttons: {
          okAdd: 'Add',
          okEdit: 'Save',
          cancel: 'Cancel',
        },
        success: 'User saved successfully.',
      },
      chat: {
        noTicketMessage: 'Select a ticket to start chatting.',
      },
      ticketsManager: {
        buttons: {
          newTicket: 'New',
        },
      },
      ticketsQueueSelect: {
        placeholder: 'Queues',
      },
      tickets: {
        toasts: {
          deleted: 'The ticket you were on has been deleted.',
        },
        notification: {
          message: 'Message from',
        },
        tabs: {
          open: { title: 'Inbox' },
          closed: { title: 'Resolved' },
          search: { title: 'Search' },
        },
        search: {
          placeholder: 'Search tickets and messages.',
        },
        buttons: {
          showAll: 'All',
          quickmessageflash: 'Quick Message',
        },
        confirmationModal: {
          deleteTitle: 'Delete ticket',
          deleteMessage: 'Do you really want to delete this ticket?',
          closeTitle: 'Close ticket',
          closeMessage: 'Do you really want to close this ticket?',
          ignoreTitle: 'Ignore ticket',
          ignoreMessage: 'Do you really want to ignore this ticket?',
        },
      },
      transferTicketModal: {
        title: 'Transfer Ticket',
        subtitle: 'Pick an agent (optional) and the destination queue.',
        close: 'Close',
        fieldLabel: 'Type to search for users',
        fieldQueueLabel: 'Transfer to queue',
        fieldQueuePlaceholder: 'Select a queue',
        noOptions: 'No user found with this name',
        buttons: {
          ok: 'Transfer',
          cancel: 'Cancel',
        },
      },
      messageInput: {
        tooltip: {
          signature: 'Enable/disable signature',
          privateMessage: 'Enable/disable private message',
          meet: 'Send video call link',
        },
        type: {
          attachFile: 'Attach file',
          imageVideo: 'Photos & videos',
          cam: 'Camera',
          document: 'Document',
          contact: 'Contact',
          meet: 'Video call',
          privateMessage: 'Private message',
          scheduleMessage: 'Schedule message',
          moreOptions: 'More options',
          moreOptionsDetail: 'More options (buttons, lists, etc.)',
          quickMessages: 'Quick messages',
          signature: 'Signature (agent name)',
          emojis: 'Emojis',
        },
      },
      quickMessages: {
        pickerEmpty: 'No quick messages saved yet.',
        noTextPreview: '(no text)',
        dialog: {
          subtitle: 'Create message shortcuts for your team.',
          insertEmoji: 'Insert emoji',
          removeAttachment: 'Remove file',
        },
      },
      ticketsList: {
        pendingHeader: 'Queue',
        assignedHeader: 'Working on',
        noTicketsTitle: 'No tickets found',
        noTicketsMessage: 'No tickets found in this tab with the current filters or search term.',
        buttons: {
          accept: 'Accept',
        },
      },
      newTicketModal: {
        title: 'Create Ticket',
        fieldLabel: 'Type to search for a contact',
        add: 'Add',
        buttons: {
          ok: 'Save',
          cancel: 'Cancel',
        },
      },
      mainDrawer: {
        listItems: {
          dashboard: 'Dashboard',
          connections: 'Connections',
          tickets: 'Tickets',
          contacts: 'Contacts',
          queues: 'Queues',
          administration: 'Administration',
          users: 'Users',
          settings: 'Settings',
        },
        appBar: {
          user: {
            profile: 'Profile',
            logout: 'Logout',
          },
        },
      },
      notifications: {
        noTickets: 'No notifications.',
      },
      queues: {
        title: 'Queues',
        table: {
          name: 'Name',
          color: 'Color',
          greeting: 'Greeting message',
          actions: 'Actions',
        },
        buttons: {
          add: 'Add queue',
        },
        confirmationModal: {
          deleteTitle: 'Delete',
          deleteMessage:
            'Are you sure? It cannot be reverted! Tickets in this queue will still exist, but will not have any queues assigned.',
        },
      },
      queueSelect: {
        inputLabel: 'Queues',
      },
      users: {
        title: 'Users',
        table: {
          name: 'Name',
          email: 'Email',
          profile: 'Profile',
          profiles: {
            admin: 'Administrator',
            user: 'User',
            owner: 'Owner',
            superAdmin: 'Super Admin',
          },
          actions: 'Actions',
        },
        buttons: {
          add: 'Add user',
        },
        toasts: {
          deleted: 'User deleted sucessfully.',
        },
        confirmationModal: {
          deleteTitle: 'Delete',
          deleteMessage: "All user data will be lost. Users' open tickets will be moved to queue.",
        },
      },
      settings: {
        success: 'Settings saved successfully.',
        title: 'Settings',
        settings: {
          userCreation: {
            name: 'User creation',
            options: {
              enabled: 'Enabled',
              disabled: 'Disabled',
            },
          },
        },
      },
      messagesList: {
        header: {
          assignedTo: 'Assigned to:',
          buttons: {
            return: 'Return',
            resolve: 'Resolve',
            reopen: 'Reopen',
            accept: 'Accept',
          },
        },
        reactionPicker: {
          moreEmojis: 'More emojis',
        },
        reactionDetail: {
          titleOne: '1 reaction',
          titleMany: '{{count}} reactions',
          you: 'You',
          clickToRemove: 'Click to remove',
          removeMyReaction: 'Remove my reaction',
          removeSessionFooterHint:
            'Use the link below to remove the reaction sent by this WhatsApp connection in the app.',
          badgeHint: 'View reactions',
        },
      },
      messagesInput: {
        placeholderOpen: 'Type a message',
        placeholderClosed: 'Reopen or accept this ticket to send a message.',
        signMessage: 'Sign',
      },
      contactDrawer: {
        header: 'Contact details',
        buttons: {
          edit: 'Edit contact',
        },
        extraInfo: 'Other information',
      },
      ticketOptionsMenu: {
        delete: 'Delete',
        transfer: 'Transfer',
        confirmationModal: {
          title: 'Delete ticket #',
          titleFrom: 'from contact ',
          message: "Attention! All ticket's related messages will be lost.",
        },
        buttons: {
          delete: 'Delete',
          cancel: 'Cancel',
        },
      },
      confirmationModal: {
        buttons: {
          confirm: 'Confirm',
          cancel: 'Cancel',
        },
      },
      messageOptionsMenu: {
        delete: 'Delete',
        reply: 'Reply',
        edit: 'Edit',
        forward: 'Forward',
        toForward: 'Forward',
        talkTo: 'Talk to',
        copyMessage: 'Copy message',
        copySuccess: 'Message copied!',
        copyNoText: 'This message has no text to copy.',
        confirmationModal: {
          title: 'Delete message?',
          message: 'This action cannot be reverted.',
        },
      },
      import: {
        page: {
          title: 'Imports',
          subtitle: 'Track WhatsApp and Meta (Facebook/Instagram) history imports',
        },
        buttons: {
          refresh: 'Refresh',
          startMeta: 'Import history (Meta)',
          backToConnections: 'Back to Connections',
        },
        emptyState: 'No imports found',
        toasts: {
          started: 'Import started',
          finished: 'Import finished',
        },
        metaModal: {
          title: 'Import history (Meta)',
          hint: 'If token is empty, the backend uses the token saved in the connection.',
          selectConnection: 'Select connection',
          selectConnectionRequired: 'Select a connection',
          loadingConnections: 'Loading connections...',
          noConnections: 'No Meta connections found',
          pageIdRequired: 'Page ID is required',
          dateStart: 'Start date',
          dateEnd: 'End date',
        },
        banner: {
          importing: 'Importing history…',
          viewDetails: 'View details',
        },
        tooltips: {
          whatsappAuto: 'WhatsApp imports automatically after connecting',
          metaRateLimit: 'Meta depends on permissions and rate limit.',
        },
      },
      campaigns: {
        massDispatchTitle: 'Mass dispatch',
        buttons: {
          add: 'New campaign',
          addPhrase: 'New phrase campaign',
        },
      },
      toastErrors: {
        generic: 'Could not complete the operation. Please try again.',
        network: 'Connection failed. Check your internet and try again.',
        timeout: 'The request took too long. Please try again.',
        serverError: 'Server error ({{status}}). Please try again in a moment.',
        notFound: 'Resource not found. Check the data and try again.',
        forbidden: 'You do not have permission to perform this action.',
        noPermissionToCreateContact:
          'You do not have permission to create contacts. Ask an administrator to start a service with this contact.',
        httpError: 'Could not complete the operation (error {{status}}). Please try again.',
        noPagePermission: 'This company does not have permission to access this page!',
        whatsappIdInput: 'Enter the WhatsApp ID.',
        fileTooLarge5mb: 'File is too large! 5MB maximum',
        selectQueue: 'Select a queue',
        selectFlow: 'Select a flow',
        ticketIdInput: 'Enter the Ticket ID.',
        enterMessageText: 'Enter the message text',
        addAtLeastOneTag: 'Add at least one tag',
        selectKanbanTag: 'Select a kanban tag',
        invoiceIdInput: 'Enter the Invoice ID.',
        userIdInput: 'Enter the User ID.',
        couldNotLoadRecords: 'Could not load the list of records',
        invalidCpfCnpj: 'Invalid CPF/CNPJ. Check the number entered.',
        errorUpdatingQueue: 'Error updating queue.',
        fileTooLarge20mb: 'File is too large! 20MB maximum',
        errorLoadingData: 'Error loading data',
        enterScheduleDateTime: 'Enter the appointment date and time.',
        dateTimeMustBeFuture: 'The date and time must be in the future.',
        delayMin1Minute: 'The delay must be at least 1 minute.',
        couldNotPerformOperation: 'Could not perform the operation',
        invalidPrimaryColor: 'Invalid primary color. Use HEX format (#RGB or #RRGGBB).',
        invalidColors: 'There are invalid colors. Use HEX format (#RGB or #RRGGBB).',
        jsonInvalidQueueIds: 'Invalid JSON in queueIds',
        tagIdToSearch: 'Enter the Tag ID to fetch a record.',
        companyNotIdentified: 'Company not identified. Log in again or select a company.',
        sourceAlreadyExists: 'This source already exists.',
        selectAtLeastOneTicket: 'Select at least one ticket',
        selectTagInContacts: 'Select the tag (in contacts)',
        enterTokenBeforeDownload: 'Enter the token before downloading the collection.',
        invalidFlow: 'Invalid flow.',
        errorFetchingZip: 'Error looking up ZIP code. Please try again.',
        nameRequiredArticle: 'Name is required.',
        invalidEmail: 'Invalid email.',
        invalidCpf: 'Invalid CPF.',
        invalidCnpj: 'Invalid CNPJ.',
        enterNewPassword: 'Enter the new password.',
        passwordsDoNotMatch: 'The passwords do not match.',
        companyCannotBeDeleted: 'This company cannot be deleted.',
        couldNotSaveValue: 'Could not save the value.',
        fileExceeds20mb: 'File exceeds the 20 MB limit',
        selectClient: 'Select a client.',
        enterInvoiceDescription: 'Enter the invoice description.',
        enterInvoiceValue: 'Enter the invoice amount.',
        enterDueDate: 'Enter the due date.',
        selectReferenceItem: 'Select the related item or clear the reference type.',
        errorSendingFile: 'Error sending file. Please try again.',
        selectFile: 'Select a file!',
        selectKanbanTagAlt: 'Select a Kanban tag',
        selectTag: 'Select a tag',
        invalidHeadersJson: 'Invalid JSON in headers',
        invalidBodyJson: 'Invalid JSON in body',
        errorTestingApi: 'Error testing API',
        enterRequestUrl: 'Enter the request URL',
        addValidCondition: 'Add at least one valid condition',
        selectPipeline: 'Select a pipeline',
        selectStage: 'Select a stage',
        enterTitle: 'Enter a title',
        selectTargetStage: 'Select the target stage',
        enterLossReason: 'Enter the loss reason',
        errorStartingAuth: 'Error starting authentication',
        enterSpreadsheetId: 'Enter the spreadsheet ID',
        errorTestingConnection: 'Error testing connection',
        selectSpreadsheet: 'Select a spreadsheet',
        enterSheetName: 'Enter the sheet name',
        addDataField: 'Add at least one data field',
        enterColumnAndValue: 'Enter the column and value to search',
        enterIntervalValue: 'Add the interval value (minimum 1 second)',
        percentAboveZero: 'Set a percentage above 0%',
        percentMax100: 'The maximum percentage is 100%',
        errorFetchingQueues: 'Error fetching queues',
        selectWhatsappConnection: 'Select a WhatsApp connection',
        enterMessage: 'Enter the message',
        invalidNumber: 'Invalid number. Use country code + area code + number (e.g. 5585999999999)',
        errorReadingMessage: 'Error reading message. Close and reopen the modal.',
        emptyMessageFields: 'Message fields are empty!',
        errorReadingInterval: 'Error reading interval. Close and reopen the modal.',
        intervalRange: 'Interval cannot be 0 or greater than 120!',
        deleteEmptyCards: 'Delete the empty cards (Image, File, Audio and Video)',
        verifyTokenEmpty: 'The verify token cannot be empty.',
        folderNameRequired: 'The folder name is required.',
        enterPaymentValue: 'Enter the payment amount.',
        tokenRequiredWhenProviderActive: 'Token is required when the provider is active.',
        couldNotRemoveAccess: 'Could not remove access',
        minChargeNotReached: 'Minimum charge amount in BRL not reached. Adjust the plan price.',
        defaultPlanCannotBeDeleted: 'The default plan cannot be deleted.',
        planHasCompanies: 'This plan has linked companies and cannot be deleted.',
        planHasInvoices: 'This plan has linked invoices and cannot be deleted.',
        couldNotLoadServices: 'Could not load the list of services',
        enterProfessionalName: 'Enter the professional name',
        errorSavingProfessional: 'Error saving professional',
        couldNotSendFile: 'Could not send the file.',
        enterTitleAndLink: 'Enter the title and the link.',
        enterValidLink: 'Enter a valid link (https://...).',
        errorSavingService: 'Error saving service',
        errorUploadingIcon: 'Error uploading the icon.',
        onlyImages: 'Upload images only (PNG, JPG, WebP or ICO).',
        noAccessPermission: 'No permission to access!',
        onlyP12Files: 'Use only files in p12 format!',
        errorSendingCertificate: 'Error sending certificate. Please try again.',
        errorSavingTheme: 'Error saving the theme.',
        errorSavingColors: 'Error saving color customization.',
        errorSavingEmailFooter: 'Error saving email footer settings.',
        serverResponseNoFilename: 'Server response without file name.',
        errorUploadingImage: 'Error uploading the image.',
        couldNotSaveBanner: 'Could not save the banner',
        couldNotLoadBanners: 'Could not load the banners',
        couldNotRemoveBanner: 'Could not remove the banner',
        invalidValue: 'Invalid value.',
        urlNotConfigured: 'URL not configured.',
        errorLinkingClient: 'Error linking client.',
        couldNotSaveAdditionalInfo: 'Could not save the additional information.',
        couldNotUpdateChatbot: 'Could not update the chatbot.',
        couldNotUpdateAudioPermission: 'Could not update the audio permission.',
        couldNotChangeContactStatus: 'Could not change the contact status.',
        titleRequired: 'Title is required',
        videoUrlRequired: 'Video URL is required',
        descriptionMax300: 'Description must be at most 300 characters',
        errorAccessingMic: 'Error accessing the microphone. Check the permissions.',
        recordingTooShort: 'Recording too short. Record for longer.',
        errorSendingAudio: 'Error sending audio. Please try again.',
        errorProcessingAudio: 'Error processing audio.',
        errorCancellingRecording: 'Error cancelling recording.',
        invalidContactForSend: 'Invalid contact for sending. Check name and number.',
        errorUpdatingHubToken: 'There was an error trying to update the Hub token.',
        clientIdToSearch: 'Enter the Client ID to fetch a record.',
        nameRequiredDot: 'Name is required.',
        contactIdToSearch: 'Enter the Contact ID to fetch a record.',
        clientValueDueRequired: 'Client, amount and due date are required.',
        invoiceIdRequired: 'Invoice ID is required.',
        queueIdToSearch: 'Enter the Queue ID to fetch a record.',
        dealIdToSearch: 'Enter the Deal ID to fetch a record.',
        productIdToSearch: 'Enter the Product ID to fetch a record.',
        serviceIdToSearch: 'Enter the Service ID to fetch a record.',
        taskIdToSearch: 'Enter the Task ID to fetch.',
        jsonInvalidTagIds: 'Invalid JSON in tagIds',
        userOrQueueToTransfer: 'Enter User ID or Queue ID to transfer.',
        jsonInvalidServiceIds: 'Invalid JSON in serviceIds',
        userIdToSearch: 'Enter the User ID to fetch.',
        userIdAndServiceIds: 'Enter User ID and serviceIds.',
        userIdAndDateTime: 'Enter User ID and Date/Time.',
        userIdAppointmentStatus: 'Enter User ID, Appointment ID and Status.',
        couldNotGetPaymentLink: 'Could not retrieve the payment link.',
        couldNotCloseTickets: 'Could not close the tickets. Please try again.',
        mustAcceptTerms: 'You must accept the terms to continue.',
        enterPipelineName: 'Enter the pipeline name',
        onlyOneWonStage: 'Only 1 stage can be marked as Won',
        onlyOneLostStage: 'Only 1 stage can be marked as Lost',
        exportedFileEmpty: 'Error: The exported file is empty',
        selectFileToImport: 'Select a file to import',
        fileMustBeJson: 'The file must be a JSON file',
        configureQueueNodes: 'Configure the queue in all "Route to Queue" nodes before saving.',
        emailNotFound: 'Email not found',
        saveIntegrationBeforeMapping: 'Save the integration before mapping fields.',
        invalidTestJson: 'Invalid test JSON.',
        selectTicketStatus: 'Select at least one ticket status',
        selectWeekday: 'Select at least one day of the week',
        profileNotFound: 'Profile not found.',
        imageMax1mb: 'Image must be at most 1 MB',
        nameRequired: 'Name is required',
        selectUser: 'Select a user',
        couldNotGetGoogleLink: 'Could not get the Google connection link.',
        allowPopups: 'Allow pop-ups on this site to connect Google Calendar.',
      },
      toastSuccess: {
        operation: 'Operation completed successfully!',
        operationUpdated: 'Operation updated successfully.',
        saved: 'Saved successfully.',
        settingsSaved: 'Settings saved!',
        settingsSavedSuccess: 'Settings saved successfully!',
        settingsReset: 'Settings reset successfully!',
        configSaved: 'Settings saved successfully.',
        configRemoved: 'Settings removed.',
        copied: 'Copied!',
        linkCopied: 'Link copied!',
        redirectUriCopied: 'Redirect URI copied!',
        webhookUrlCopied: 'Webhook URL copied!',
        clickSaveToApply: 'Click save to apply the changes.',
        exported: 'Data exported successfully!',
        testSuccess: 'Test completed successfully!',
        connectionTested: 'Connection tested successfully!',
        fileSent: 'File sent successfully!',
        filesSent: 'Files sent successfully.',
        fileRemoved: 'File removed successfully.',
        fileUploaded: 'File sent.',
        fileAdded: 'File added successfully!',
        contentAdded: 'Content added successfully!',
        audioAdded: 'Audio added successfully!',
        videoAdded: 'Video added successfully!',
        videoCreated: 'Video created successfully!',
        videoUpdated: 'Video updated successfully!',
        videoRemoved: 'Video removed successfully!',
        folderCreated: 'Folder created successfully!',
        folderUpdated: 'Folder updated successfully!',
        folderDeleted: 'Folder deleted successfully!',
        knowledgeFileAdded: 'File added to the knowledge base!',
        knowledgeLinkAdded: 'Link added to the knowledge base!',
        appointmentCreated: 'Appointment created successfully.',
        appointmentUpdated: 'Appointment updated successfully.',
        appointmentDeleted: 'Appointment deleted successfully.',
        statusUpdated: 'Status updated.',
        scheduleCreated: 'Schedule created successfully.',
        scheduleUpdated: 'Schedule updated successfully.',
        scheduleDeleted: 'Schedule deleted successfully.',
        googleCalendarLinked: 'Schedule linked to your Google Calendar successfully!',
        googleCalendarUnlinked: 'Google Calendar unlinked from the schedule.',
        googleCalendarDisconnected: 'Google Calendar disconnected successfully.',
        taskCreated: 'Task created successfully!',
        taskUpdated: 'Task updated successfully!',
        taskRemoved: 'Task removed.',
        taskRestored: 'Task restored.',
        taskTrashed: 'Task moved to trash.',
        taskDeletedPermanently: 'Task permanently deleted.',
        opportunityRestored: '"{{title}}" restored successfully.',
        opportunityDeletedPermanently: 'Opportunity permanently deleted.',
        companyCreated: 'Company created successfully!',
        planAccessRemoved: 'Access removed from the plan.',
        appUpdated: 'App updated successfully.',
        appActivated: '{{app}} activated.',
        appActivatedSuccess: '{{app}} activated successfully!',
        appActivatedInvoicePaid: '{{app}} activated — the invoice was already paid.',
        appDeactivated: '{{app}} deactivated.',
        appRequestCancelled: '{{app}} request cancelled.',
        paymentConfirmed: 'Payment confirmed.',
        appPaymentConfirmed: 'Payment confirmed — {{app}} unlocked.',
        redirectingToPayment: 'Redirecting to payment...',
        licenseRenewed: 'Your license has been renewed until {{date}}!',
        openPaymentTab: 'Open the tab to complete the payment.',
        aiCreditsReversed: 'Credits reversed successfully.',
        aiCreditsRequestSent: 'Request sent. Awaiting administrator approval.',
        aiCreditsRequestRejected: 'Request rejected.',
        aiCreditsRequestCancelled: 'Request cancelled.',
        aiCreditsRenewed: 'AI credits renewed successfully!',
        aiCreditsAddedToAccount: 'Credits added to your account.',
        aiCreditsAdded: '{{credits}} credits added to {{company}}.',
        apiKeySaved: '{{label}} key saved successfully.',
        apiKeyRemoved: '{{label}} key removed.',
        markupUpdated: 'Markup updated.',
        modelCreated: 'Model registered.',
        modelUpdated: 'Model updated.',
        modelDisabled: 'Model disabled.',
        metaCredentialsSaved: 'Facebook/Meta credentials saved successfully.',
        googleCredentialsSaved: 'Google credentials saved successfully.',
        smtpSaved: 'SMTP settings saved successfully.',
        openaiKeySaved: 'OpenAI key saved successfully.',
        whatsappOfficialSaved: 'Official WhatsApp settings saved successfully.',
        pixEfiSaved: 'Pix Efí settings saved successfully.',
        googleSheetsAuthenticated: 'Authenticated with Google Sheets!',
        integrationCreated: 'Integration created.',
        integrationUpdated: 'Integration updated.',
        integrationRemoved: 'Integration removed.',
        mappingSaved: 'Mapping saved.',
        baseUrlSaved: 'Copied and base URL saved on the backend!',
        whatsappConnected: 'WhatsApp connected successfully!',
        contactBlocked: 'Contact blocked.',
        contactUnblocked: 'Contact unblocked.',
        contactsImported: 'Contacts imported from the connection.',
        spreadsheetImported: 'Spreadsheet imported.',
        noteAdded: 'Note added successfully!',
        noteDeleted: 'Note deleted successfully!',
        clientCreated: 'Client created successfully!',
        clientUpdated: 'Client updated successfully!',
        ticketValueUpdated: 'Ticket value updated!',
        queueUpdated: 'Queue updated!',
        allTicketsClosed: 'All {{status}} tickets have been closed.',
        chatbotEnabled: 'Chatbot enabled.',
        chatbotDisabled: 'Chatbot disabled.',
        contactActivated: 'Contact activated successfully.',
        contactDeactivated: 'Contact deactivated.',
        pipelineCreated: 'Pipeline created!',
        pipelineSaved: 'Pipeline saved!',
        pipelineDeleted: 'Pipeline deleted!',
        crmFieldCreated: 'Field created.',
        crmFieldUpdated: 'Field updated.',
        crmFieldRemoved: 'Field removed.',
        crmSourceCreated: 'Source created!',
        crmSourceRemoved: 'Source removed.',
        automationCreated: 'Automation created.',
        automationUpdated: 'Automation updated.',
        automationRemoved: 'Automation removed.',
        triggerCreated: 'Trigger created successfully.',
        triggerUpdated: 'Trigger updated successfully.',
        triggerRemoved: 'Trigger removed.',
        productSaved: 'Product saved successfully.',
        productCreated: 'Product created successfully.',
        productUpdated: 'Product updated.',
        productDeleted: 'Product deleted.',
        variantCreated: 'Variant created.',
        variantUpdated: 'Variant updated.',
        variantDeleted: 'Variant deleted.',
        variantsGenerated: 'Variants generated.',
        categoryCreated: 'Category created.',
        categoryUpdated: 'Category updated.',
        categoryDeleted: 'Category deleted.',
        attributeCreated: 'Attribute created.',
        attributeUpdated: 'Attribute updated.',
        attributeDeleted: 'Attribute deleted.',
        optionDeleted: 'Option deleted.',
        professionalCreated: 'Professional created successfully!',
        professionalUpdated: 'Professional updated successfully!',
        professionalRemoved: 'Professional removed successfully!',
        serviceCreated: 'Service created successfully!',
        serviceRemoved: 'Service removed successfully!',
        serviceUpdated: 'Service updated successfully!',
        queueHoursSet: 'Hours set successfully!',
        queueHoursUpdated: 'Hours updated successfully!',
        phraseCreated: 'Phrase created successfully!',
        phraseUpdated: 'Phrase changed successfully!',
        phraseDeleted: 'Phrase deleted.',
        campaignDeleted: 'Campaign deleted.',
        flowCreated: 'Flow created successfully.',
        flowUpdated: 'Flow updated successfully.',
        flowSaved: 'Flow saved successfully.',
        flowDeleted: 'Flow deleted successfully.',
        flowDuplicated: 'Flow duplicated successfully.',
        flowExported: 'Flow exported successfully.',
        flowImported: 'Flow "{{name}}" imported successfully!',
        defaultFlowsUpdated: 'Default flows updated.',
        followUpScheduled: 'Follow-up scheduled.',
        followUpCancelled: 'Follow-up cancelled.',
        followUpCreated: 'Follow-up created successfully.',
        followUpByTagScheduled: 'Follow-up by tag scheduled.',
        followUpsByTagScheduled: '{{count}} follow-ups by tag scheduled.',
        followUpsCreated: '{{count}} follow-ups created successfully.',
        allTicketFollowUpsCancelled: 'All ticket follow-ups have been cancelled.',
        processingTriggered: 'Processing triggered.',
        noResponseRuleCreated: 'No-response time rule created.',
        noResponseRuleUpdated: 'No-response time rule updated.',
        recurringRuleCreated: 'Recurring follow-up rule created.',
        recurringRuleUpdated: 'Recurring follow-up rule updated.',
        tagContactsRuleCreated: 'Rule by tag (contacts) created.',
        ruleDeleted: 'Rule deleted.',
        bannerCreated: 'Banner created successfully!',
        bannerUpdated: 'Banner updated successfully!',
        bannerRemoved: 'Banner removed successfully!',
        colorsSaved: 'Customization colors saved successfully.',
        themeSaved:
          'The entire theme was saved: Menu, Buttons and Links, Typography and primary color (when changed).',
        emailFooterSaved: 'Email footer settings saved successfully.',
        tabTitleUpdated: 'Tab title updated successfully.',
        tabIconUpdated: 'Tab icon updated successfully.',
        pwaIconUpdated: 'PWA icon updated. The backend generated the default sizes.',
        invoiceCopyGenerated: 'Duplicate invoice generated successfully.',
        paymentRegistered: 'Payment registered successfully.',
        paymentRemoved: 'Payment removed.',
        invoiceDeleted: 'Invoice deleted successfully.',
        subscriptionCancelled: 'Subscription cancelled.',
        subscriptionReactivated: 'Subscription reactivated.',
        kanbanCreated: 'Kanban created successfully!',
        kanbanTagDeleted: 'Kanban tag deleted successfully.',
        reasonSaved: 'Reason saved.',
        reasonCreated: 'Reason created!',
        reasonRemoved: 'Reason removed.',
        tokenGenerated: 'Token generated successfully!',
        tokenCopied: 'Token copied to the clipboard!',
        tokenRemoved: 'Token removed successfully!',
        messageSent: 'Message sent successfully.',
        notificationSent: 'Notification sent!',
        notificationRemoved: 'Notification removed.',
        notificationsEnabled:
          'Notifications enabled. You will receive alerts about new leads and messages.',
        iaWorkflowDeleted: 'AI workflow deleted successfully!',
        profileUpdated: 'Profile updated successfully!',
        quickMessageDeleted: 'Quick reply deleted successfully.',
        importStarted: 'Import started.',
        queueDeleted: 'Queue deleted successfully.',
        emailSent: 'Email sent successfully.',
        newCodeSent: 'New code sent to your email.',
        passwordChanged: 'Password changed successfully.',
      },
      toastInfo: {
        cepNotFound: 'ZIP code not found.',
        noChangesToSave: 'No changes to save.',
        noColorChangesToSave: 'No color changes to save.',
        googleAuthWaiting: 'Still waiting for Google authentication.',
        completeAuthInWindow: 'Complete the authentication in the opened window.',
        paymentNotConfirmedYet: 'Payment is not confirmed yet. Please wait and try again.',
        qrNotAvailableYet: 'QR Code not available yet.',
        chargeRequested: 'Charge requested. Check your invoices shortly.',
        notificationsDisabled: 'Notifications disabled.',
        preparingFlowExport: 'Preparing flow export...',
        importingFlow: 'Importing flow, please wait...',
        addAtLeastOneMapping: 'Add at least one mapping.',
        couldNotVerifyConnections: 'Could not verify the connections. Please try again.',
        themeApplied:
          'Theme applied to the draft (including the primary color). Use "Save entire theme" above or save each section below to persist on the server.',
      },
      toastWarning: {
        invalidCreditValue: 'Enter a valid credit value.',
        apiKeyRequired: 'Enter the {{label}} API key.',
        modelIdRequired: 'Enter the model identifier.',
        providerRequired: 'Select the provider.',
        modelPricesRequired: 'Enter the input and output prices (USD per 1M tokens).',
        defaultPlanCannotEdit: 'This is a system default plan and cannot be changed.',
        defaultPlanCannotDelete: 'This is a system default plan and cannot be deleted.',
        configureAtLeastOneField: 'Configure at least one field to update.',
        nameMinLength: 'Enter a name with at least 2 characters.',
        automationNameRequired: 'Enter a name for the automation.',
        statusRequired: 'Select the status.',
        addAtLeastOneAction: 'Add at least one action.',
        categoryNameRequired: 'Enter the category name.',
        optionNameRequired: 'Fill in the option name.',
        abbreviationRequired: 'Fill in the abbreviation.',
        attributeNameRequired: 'Enter the attribute name.',
        productNameRequired: 'Fill in the product name.',
        productNameRequiredToContinue: 'Fill in the product name to continue.',
        invoiceCopyFailed: 'Could not generate the duplicate invoice.',
        chargeFailed: 'Could not generate the charge.',
      },
      apiDocs: {
        clientsLoaded: 'Clients loaded!',
        clientLoaded: 'Client loaded!',
        clientCreated: 'Client created successfully!',
        clientUpdated: 'Client updated successfully!',
        clientRemoved: 'Client removed!',
        queuesLoaded: 'Queues loaded!',
        queueLoaded: 'Queue loaded!',
        queueCreated: 'Queue created successfully!',
        queueUpdated: 'Queue updated successfully!',
        queueRemoved: 'Queue removed!',
        connectionsLoaded: 'Connections loaded!',
        connectionLoaded: 'Connection loaded!',
        statusLoaded: 'Status loaded!',
        connectionUpdated: 'Connection updated!',
        connectionRestarting: 'Connection restarting!',
        connectionDisconnected: 'Connection disconnected!',
        connectionCreated: 'Connection created! Wait for the QR Code.',
        qrAvailable: 'QR Code available!',
        connectionRemoved: 'Connection removed!',
        servicesLoaded: 'Services loaded!',
        serviceLoaded: 'Service loaded!',
        serviceRemoved: 'Service removed!',
        tagsLoaded: 'Tags loaded!',
        tagLoaded: 'Tag loaded!',
        tagCreated: 'Tag created successfully!',
        tagUpdated: 'Tag updated successfully!',
        tagRemoved: 'Tag removed!',
        tasksLoaded: 'Tasks loaded!',
        taskLoaded: 'Task loaded!',
        taskCreated: 'Task created successfully!',
        taskUpdated: 'Task updated successfully!',
        taskRemoved: 'Task removed!',
        contactsLoaded: 'Contacts loaded!',
        contactLoaded: 'Contact loaded!',
        contactCreated: 'Contact created successfully!',
        contactUpdated: 'Contact updated successfully!',
        contactRemoved: 'Contact removed!',
        invoicesLoaded: 'Invoices loaded!',
        invoiceLoaded: 'Invoice loaded!',
        invoiceCreated: 'Invoice created!',
        invoiceUpdated: 'Invoice updated!',
        invoicePaid: 'Invoice marked as paid!',
        invoiceCancelled: 'Invoice cancelled!',
        invoiceRemoved: 'Invoice removed!',
        dealsLoaded: 'Deals loaded!',
        dealLoaded: 'Deal loaded!',
        dealCreated: 'Deal created successfully!',
        dealUpdated: 'Deal updated successfully!',
        dealRemoved: 'Deal removed!',
        productsLoaded: 'Products loaded!',
        productLoaded: 'Product loaded!',
        productCreated: 'Product created successfully!',
        productUpdated: 'Product updated successfully!',
        productRemoved: 'Product removed!',
        usersLoaded: 'Users loaded!',
        userLoaded: 'User loaded!',
        userCreated: 'User created successfully!',
        userUpdated: 'User updated successfully!',
        userRemoved: 'User removed!',
        servicesUpdated: 'Services updated!',
        scheduleLoaded: 'Schedule loaded!',
        scheduleCreated: 'Schedule created!',
        appointmentsLoaded: 'Appointments loaded!',
        appointmentCreated: 'Appointment created!',
        statusUpdated: 'Status updated!',
        tagsKanbanLoaded: 'Kanban tags loaded!',
        tagKanbanLoaded: 'Kanban tag loaded!',
        tagKanbanCreated: 'Kanban tag created successfully!',
        tagKanbanUpdated: 'Kanban tag updated successfully!',
        tagKanbanRemoved: 'Kanban tag removed!',
        ticketsLoaded: 'Tickets loaded!',
        ticketLoaded: 'Ticket loaded!',
        messagesLoaded: 'Messages loaded!',
        ticketUpdated: 'Ticket updated!',
        ticketClosed: 'Ticket closed!',
        ticketReopened: 'Ticket reopened!',
        ticketTransferred: 'Ticket transferred!',
      },
      backendErrorTokens: {
        ACCESS: 'access',
        ACTIVE: 'active',
        ANNOUNCEMENT: 'announcement',
        API: 'API',
        APP: 'app',
        APPOINTMENT: 'appointment',
        AUTH: 'authentication',
        AUTOMATION: 'automation',
        BRL: 'BRL',
        CAMPAIGN: 'campaign',
        CHAT: 'chat',
        CHATBOT: 'chatbot',
        CLIENT: 'client',
        CODE: 'code',
        COMPANY: 'company',
        CONFIGURED: 'configured',
        CONNECTION: 'connection',
        CONTACT: 'contact',
        CREDENTIALS: 'credentials',
        CREATION: 'creation',
        DELETE: 'deletion',
        DISABLED: 'disabled',
        DUPLICATED: 'duplicated',
        EMAIL: 'email',
        EXPIRED: 'expired',
        EXTERNAL: 'external',
        FACEBOOK: 'Facebook',
        FATURA: 'invoice',
        FETCH: 'fetch',
        FORBIDDEN: 'forbidden',
        FOUND: 'found',
        INACTIVE: 'inactive',
        INTEGRATIONS: 'integrations',
        INTERNAL: 'internal',
        INVALID: 'invalid',
        MEDIA: 'media',
        MESSAGE: 'message',
        MISSING: 'missing',
        NAME: 'name',
        NO: 'no',
        NOT: 'not',
        OPENAI: 'OpenAI',
        PASSWORD: 'password',
        PERMISSION: 'permission',
        PLAN: 'plan',
        PROJECT: 'project',
        QUEUE: 'queue',
        REQUIRED: 'required',
        ROUTE: 'route',
        SENDING: 'sending',
        SERVICE: 'service',
        SESSION: 'session',
        SUBSCRIPTION: 'subscription',
        TAG: 'tag',
        TASK: 'task',
        TICKET: 'ticket',
        TOKEN: 'token',
        USER: 'user',
        VALIDATION: 'validation',
        VALUE: 'value',
        WAPP: 'WhatsApp',
        WHATSAPP: 'WhatsApp',
      },
      backendErrors: {
        ERR_NO_OTHER_WHATSAPP: 'There must be at lest one default WhatsApp connection.',
        ERR_NO_DEF_WAPP_FOUND: 'No default WhatsApp found. Check connections page.',
        ERR_WAPP_NOT_INITIALIZED:
          'This WhatsApp session is not initialized. Check connections page.',
        ERR_WAPP_CHECK_CONTACT: 'Could not check WhatsApp contact. Check connections page.',
        ERR_WAPP_INVALID_CONTACT: 'This is not a valid whatsapp number.',
        ERR_WAPP_DOWNLOAD_MEDIA: 'Could not download media from WhatsApp. Check connections page.',
        ERR_INVALID_CREDENTIALS: 'Authentication error. Please try again.',
        ERR_INVALID_TOKEN: 'Invalid token. Please login again.',
        ERR_SENDING_WAPP_MSG: 'Error sending WhatsApp message. Check connections page.',
        ERR_SENDING_FACEBOOK_MSG: 'Error sending Facebook/Instagram message. Check the connection.',
        instagram_does_not_support_this_media_type:
          'Instagram does not support this file type. Please send JPEG, PNG, GIF, or WEBP images only.',
        ERR_DELETE_WAPP_MSG: "Couldn't delete message from WhatsApp.",
        ERR_OTHER_OPEN_TICKET: "There's already an open ticket for this contact.",
        ERR_SESSION_EXPIRED: 'Session expired. Please login.',
        ERR_NO_AUTH_TOKEN: 'Request without authorization token. Please login again.',
        ERR_ACCESS_TOKEN_EXPIRED: 'Access token expired. Refresh the page or login again.',
        ERR_REFRESH_TOKEN_MISSING: 'Refresh token missing. Please login again.',
        ERR_REFRESH_TOKEN_EXPIRED: 'Refresh token expired. Please login again.',
        ERR_REFRESH_TOKEN_INVALID: 'Refresh token invalid. Please login again.',
        ERR_SESSION_REVOKED:
          'Session revoked (e.g. logout from another device). Please login again.',
        ERR_AUTH_REQUIRED: 'Authentication required. Please login to continue.',
        ERR_APP_NOT_ACTIVE:
          'The app or integration is not active. Check your settings or contact support.',
        ERR_PLAN_INTERNAL_CHAT_DISABLED:
          "Internal chat is not available for the company's current plan.",
        ERR_PLAN_INTEGRATIONS_DISABLED:
          "Integrations are not available for the company's current plan.",
        ERR_COMPANY_APP_ALREADY_CANCELLED: 'This app has already been deactivated.',
        ERR_COMPANY_TOKEN_MISSING: 'Company token not provided.',
        ERR_COMPANY_TOKEN_NOT_CONFIGURED: 'Company token not configured on server.',
        ERR_COMPANY_TOKEN_INVALID: 'Invalid company token.',
        ERR_API_TOKEN_MISSING: 'API token not provided.',
        ERR_API_TOKEN_NOT_CONFIGURED: 'Integration token not configured.',
        ERR_API_TOKEN_INVALID: 'Invalid API token.',
        ERR_USER_CREATION_DISABLED: 'User creation was disabled by administrator.',
        ERR_NO_PERMISSION: "You don't have permission to access this resource.",
        ERR_DUPLICATED_CONTACT: 'A contact with this number already exists.',
        ERR_NO_SETTING_FOUND: 'No setting found with this ID.',
        ERR_NO_CONTACT_FOUND: 'No contact found with this ID.',
        ERR_NO_TICKET_FOUND: 'No ticket found with this ID.',
        ERR_NO_USER_FOUND: 'No user found with this ID.',
        ERR_NO_WAPP_FOUND: 'No WhatsApp found with this ID.',
        ERR_CREATING_MESSAGE: 'Error while creating message on database.',
        ERR_CREATING_TICKET: 'Error while creating ticket on database.',
        ERR_FETCH_WAPP_MSG: 'Error fetching the message in WhtasApp, maybe it is too old.',
        ERR_QUEUE_COLOR_ALREADY_EXISTS: 'This color is already in use, pick another one.',
        ERR_WAPP_GREETING_REQUIRED: 'Greeting message is required if there is more than one queue.',
        ERR_EMAIL_ALREADY_EXISTS: 'This email is already in use.',
        ERR_COMPANY_NAME_ALREADY_EXISTS: 'This company name is already registered.',
        ERR_COMPANY_DOCUMENT_ALREADY_EXISTS: 'This company document is already registered.',
        ERR_UNIQUE_CONSTRAINT_VIOLATION:
          'A record with this value already exists. Check the fields and try again.',
        ERR_META_IMPORT_TOKEN_MISSING:
          'Connect the page in Settings > Connections before importing.',
        ERR_META_IMPORT_PAGE_NOT_FOUND: 'Page not found. Link the page in Settings > Connections.',
        ERR_ROUTE_NOT_FOUND: 'Route or resource not found. Check the address or try again.',
        ERR_CREATING_FOLLOW_UP: 'Could not create follow-up. Check the data and try again.',
        ERR_PASSWORD_RESET_CODE_INVALID:
          'Invalid or expired code. Check the code or request a new one.',
        ERR_PROMPT_INTELLIGENCE_INVALID:
          "This prompt's intelligence settings are invalid. Check the model, tools, and required fields.",
        missing_code_or_state: 'Authorization cancelled or expired. Please try again.',
        invalid_or_expired_state: 'Authorization session expired. Please start the process again.',
        no_pages_found:
          'Your account does not manage any Facebook Page. To use Messenger or Instagram chat, you need to be an admin of a Facebook Page.',
        subscribe_failed:
          'Page connected, but the webhook was not activated. Make sure the app is in Live mode.',
        token_exchange_failed: 'Error authenticating the page. Please try reconnecting.',
        conflict:
          'This page is already in use by another account. Disconnect it before continuing.',
        ERR_REACTIONS_WHATSAPP_ONLY: 'Reactions are only available on WhatsApp tickets.',
        ERR_REACTIONS_INVALID_TARGET: 'You cannot react to this message type.',
        ERR_REACTIONS_NOT_AVAILABLE_PRIVATE: 'You cannot react to private messages.',
        ERR_MESSAGE_KEY_UNAVAILABLE:
          'Cannot react: WhatsApp message key/data is not available for this message.',
        ERR_SENDING_WAPP_REACTION:
          'Failed to send the reaction on WhatsApp. Check the session and try again.',
        ERR_WAPP_NOT_CONNECTED: 'WhatsApp is not connected. Check the connections page.',
        ERR_CLIENT_REACTION_INVALID_MESSAGE_ID:
          'Wait until the message is saved on the server before reacting.',
      },
    },
  },
};

export { messages };
